import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Footer() {
  const brands = [
    {
      name: "Apple",
      logo: "https://cdn.simpleicons.org/apple/ffffff",
      path: "/refurbished-laptops/apple/macbooks",
    },
    {
      name: "Dell",
      logo: "https://cdn.simpleicons.org/dell/ffffff",
      path: "/refurbished-laptops/dell/laptops",
    },
    {
      name: "HP",
      logo: "https://cdn.simpleicons.org/hp/ffffff",
      path: "/refurbished-laptops/hp/laptops",
    },
    {
      name: "Lenovo",
      logo: "https://cdn.simpleicons.org/lenovo/ffffff",
      path: "/refurbished-laptops/lenovo/laptops",
    },
    {
      name: "Asus",
      logo: "https://cdn.simpleicons.org/asus/ffffff",
      path: "/refurbished-laptops/asus/laptops",
    },
    {
      name: "MSI",
      logo: "https://cdn.simpleicons.org/msi/ffffff",
      path: "/refurbished-laptops/msi/laptops",
    },
    {
      name: "Acer",
      logo: "https://cdn.simpleicons.org/acer/ffffff",
      path: "/refurbished-laptops/acer/laptops",
    }
  ];


  return (
    <footer className="bg-gradient-to-br from-black via-slate-900 to-black text-gray-300">

      {/* -------------------------- BRAND SCROLLER -------------------------- */}
      <div className="relative bg-black border-b border-white/10 py-6 overflow-hidden">

        {/* Fade edges for brand scroller */}
        <div className="pointer-events-none absolute left-0 top-0 h-full w-12 sm:w-24 bg-gradient-to-r from-black to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 h-full w-12 sm:w-24 bg-gradient-to-l from-black to-transparent z-10" />

        {/* Scrolling logos */}
        <div className="overflow-hidden">
          <div
            className="flex w-[200%] gap-10 sm:gap-20 animate-[scroll_25s_linear_infinite] hover:[animation-play-state:paused]"
            style={{ animationName: "scroll" }}
          >
            {/* GROUP 1 */}
            <div className="flex w-1/2 justify-around items-center">
              {brands.map((brand, i) => (
                <Link
                  key={`a-${i}`}
                  to={brand.path}
                  className="flex-shrink-0"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    title={brand.name}
                    className="h-8 sm:h-10 md:h-14 opacity-60 hover:opacity-100 hover:scale-110 transition cursor-pointer"
                  />
                </Link>
              ))}
            </div>

            {/* GROUP 2 (CLONE for infinite scroll) */}
            <div className="flex w-1/2 justify-around items-center">
              {brands.map((brand, i) => (
                <Link
                  key={`b-${i}`}
                  to={brand.path}
                  className="flex-shrink-0"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    title={brand.name}
                    className="h-8 sm:h-10 md:h-14 opacity-60 hover:opacity-100 hover:scale-110 transition cursor-pointer"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Tailwind keyframes for scrolling */}
        <style>
          {`
            @keyframes scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>
      </div>

      {/* -------------------------- FOOTER CONTENT -------------------------- */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

          {/* LEFT: Logo & Description */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src={logo}
              alt="Credible Technologies Logo"
              className="w-16 sm:w-24 md:w-32 aspect-square rounded-full object-contain bg-white p-2"
            />

            {/* Optional heading if you want to display company name */}
            {/* 
            <h2 className="text-3xl font-bold text-white">
              Credible <span className="text-blue-500">Technologies</span>
            </h2> 
            */}

            <p className="text-sm sm:text-base text-gray-400 max-w-xs text-center md:text-left">
              Trusted laptop buy, sell & repair experts since 2017.
            </p>
          </div>

          {/* MIDDLE: Quick Links & Services */}
          <div className="grid grid-cols-2 gap-x-6 sm:gap-x-12 gap-y-4 sm:gap-y-6 text-sm text-center md:text-left">

            {/* Quick Links */}
            <div>
              <p className="text-blue-500 font-semibold mb-3">Quick Links</p>
              <div className="flex flex-col space-y-2 sm:space-y-3">
                <Link to="/" className="text-gray-300 hover:text-white">
                  Home
                </Link>

                <Link to="/aboutus" className="text-gray-300 hover:text-white">
                  About Us
                </Link>

                <Link to="/contactus" className="text-gray-300 hover:text-white">
                  Contact Us
                </Link>
              </div>
            </div>

            {/* Services */}
            <div>
              <p className="text-blue-500 font-semibold mb-3">Services</p>
              <div className="flex flex-col space-y-2 sm:space-y-3">
                <a
                  href="https://wa.me/919538577199?text=Hello%2C%20I%20would%20like%20to%20sell%20my%20laptop.%20Please%20let%20me%20know%20the%20process%20and%20expected%20price."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white"
                >
                  Sell Your Laptop
                </a>

                <a
                  href="https://wa.me/919538577199?text=Hello%2C%20I%20am%20interested%20in%20buying%20a%20refurbished%20laptop.%20Please%20share%20available%20models%20and%20pricing."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white"
                >
                  Buy Refurbished
                </a>
              </div>
            </div>

          </div>

          {/* RIGHT: Contact Information */}
          <div className="flex flex-col gap-4 text-sm text-center md:text-left">

            {/* Address */}
            <div className="flex flex-col sm:flex-row sm:gap-3 items-center sm:items-start">
              <div className="flex flex-col sm:flex-row sm:gap-3 items-start">
                <FaMapMarkerAlt className="text-blue-500 mt-1" />
                <div className="flex flex-col">
                  <p className="leading-relaxed text-xs sm:text-sm">
                    1093, 26th B Main Rd, opposite Trends Woman, Putlanpalya, Jayanagara 9th Block<br />
                    Jayanagar, Bengaluru, Karnataka 560069
                  </p>

                  {/* Get Directions Button */}
                  <a
                    href="https://maps.app.goo.gl/s19uKCD9q6SkHqRz9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 ml-6 bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition text-sm sm:text-base text-center w-max"
                  >
                    Get Directions
                  </a>
                </div>
              </div>

            </div>

            {/* Phone */}
            <div className="flex gap-3 justify-center md:justify-start">
              <FaPhoneAlt className="text-blue-500 mt-1" />
              <p className="text-xs sm:text-sm">+91 95385 77199</p>
            </div>

            {/* Email */}
            <div className="flex gap-3 justify-center md:justify-start">
              <FaEnvelope className="text-blue-500 mt-1" />
              <p className="text-xs sm:text-sm">imthiaz@credibletech.in</p>
            </div>

            {/* Optional Social Icons */}
            {/*
            <div className="flex gap-4 pt-4 justify-center md:justify-start">
              <a className="p-3 bg-white/10 rounded-full hover:bg-pink-600 transition">
                <FaInstagram />
              </a>
              <a className="p-3 bg-white/10 rounded-full hover:bg-green-600 transition">
                <FaWhatsapp />
              </a>
            </div>
            */}

          </div>

        </div>
      </div>

      {/* -------------------------- COPYRIGHT -------------------------- */}
      <div className="border-t border-white/10 py-6 text-center font-bold text-xs sm:text-sm text-gray-400">
        © 2025 Credible Technologies. All rights reserved. |{" "}
        <a
          href="https://navelio.in"
          target="_blank"
          rel="noreferrer"
          className="text-blue-500 font-bold transition-all duration-300 hover:text-transparent hover:bg-clip-text 
          hover:bg-gradient-to-r hover:from-orange-500 hover:via-white hover:to-green-500"
        >
          ⚡ Crafted with Code by Navelio.in
        </a>
      </div>
    </footer>
  );
}
